import { render, staticRenderFns } from "./RichObjectDisplay.vue?vue&type=template&id=4c2a6e2a&scoped=true"
import script from "./RichObjectDisplay.vue?vue&type=script&lang=js"
export * from "./RichObjectDisplay.vue?vue&type=script&lang=js"
import style0 from "./RichObjectDisplay.vue?vue&type=style&index=0&id=4c2a6e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a6e2a",
  null
  
)

export default component.exports